import React, { Component } from 'react'
import cs from 'classnames'
import { FormattedMessage } from 'react-intl'
import Slider from 'react-slick'

import { isIos } from 'src/utils/helpers'
import Button from 'src/components/Button'

import Intro from './pages/intro'
import AndroidStep1 from './pages/android/step1'
import AndroidStep2 from './pages/android/step2'
import AndroidStep3 from './pages/android/step3'
import AndroidStep4 from './pages/android/step4'
import AndroidStep5 from './pages/android/step5'

import IosStep1 from './pages/ios/step1'
import IosStep2 from './pages/ios/step2'
import IosStep3 from './pages/ios/step3'
import IosStep4 from './pages/ios/step4'

import styles from './styles.module.less'
import './slider.less'

const iOSSlides = language => [
  <Intro key='iosIntro' language={language} />,
  <IosStep1 key='iosStep1' language={language} />,
  <IosStep2 key='iosStep2' language={language} />,
  <IosStep3 key='iosStep3' language={language} />,
  <IosStep4 key='iosStep4' language={language} />,
]

const iOSSlidesLength = iOSSlides().length - 1

const AndroidSlides = language => [
  <Intro key='androidIntro' language={language} />,
  <AndroidStep1 key='androidStep1' language={language} />,
  <AndroidStep2 key='androidStep2' language={language} />,
  <AndroidStep3 key='androidStep3' language={language} />,
  <AndroidStep4 key='androidStep4' language={language} />,
  <AndroidStep5 key='androidStep5' language={language} />,
]

const androidSlidesLength = AndroidSlides().length - 1

class LockModal extends Component {
  sliderRef = null

  state = {
    showDots: true,
    currentSlide: 0,
  }

  handleRef = ref => {
    this.sliderRef = ref
  }

  handleNext = () => {
    const { onClose } = this.props
    const { currentSlide } = this.state

    if (isIos()) {
      if (currentSlide === iOSSlidesLength) {
        onClose()
        this.setState({
          currentSlide: 0,
        })
      } else {
        this.sliderRef.slickNext()
      }
    }

    if (currentSlide === androidSlidesLength) {
      onClose()
      this.setState({
        currentSlide: 0,
      })
    } else {
      this.sliderRef.slickNext()
    }
  }

  renderButtonText = () => {
    const { currentSlide } = this.state

    let isFinish = false
    if (isIos()) {
      isFinish = currentSlide === iOSSlidesLength
    } else {
      isFinish = currentSlide === androidSlidesLength
    }

    if (isFinish) {
      return <FormattedMessage id='app.lock.modal.finish' defaultMessage='Finish' />
    } else {
      return <FormattedMessage id='app.lock.modal.skip' defaultMessage='Skip' />
    }
  }

  renderSlides = () => {
    const { language } = this.props

    if (isIos()) {
      return iOSSlides(language)
    }
    return AndroidSlides(language)
  }

  render() {
    const { show } = this.props
    const settings = {
      accessibility: true,
      adaptiveHeight: true,
      infinite: false,
      speed: 500,
      dots: this.state.showDots,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      afterChange: currentSlide => {
        this.setState({
          currentSlide,
        })
      },
    }

    // TODO: remove this when animation is added
    if (!show) {
      return null
    }

    return (
      <div
        className={cs(styles.fabModal, {
          [styles.fabModalOpen]: show,
        })}
      >
        {this.state.currentSlide !== 0 && (
          <Button position='absolute' className={styles.closeLockBtn} onClick={this.handleNext}>
            {this.renderButtonText()}
          </Button>
        )}
        <Slider ref={this.handleRef} {...settings}>
          {this.renderSlides()}
        </Slider>
      </div>
    )
  }
}

export default LockModal
